import React from 'react';

import InfobookIcon from './InfobookIcon';
import { useNavigate } from 'react-router-dom';

const IconColumnTwo = () => {
  const navigate = useNavigate();
  
  return (
    <div className="icon-column">
      <InfobookIcon iconName="IoCopy" itemText="Templates" onClick={() => navigate('/infobook/templates')}/>
      <InfobookIcon iconName="IoAlbums" itemText="Resources" disabled />
      <div style={{ height: '60px' }}></div>
    </div>
  );
}

export default IconColumnTwo;
